import api from './api';
import { PackageUnit, CreatePackageUnitData, UpdatePackageUnitData } from '../types/packageUnit';

export const packageUnitService = {
  // Get all units for a package
  getByPackage: async (
    workspaceId: string,
    packageId: string
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/units`
    );
    return response.data;
  },

  // Add a unit to a package
  create: async (
    workspaceId: string,
    packageId: string,
    data: CreatePackageUnitData
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/units`,
      data
    );
    return response.data;
  },

  // Add multiple units to a package
  createMultiple: async (
    workspaceId: string,
    packageId: string,
    units: CreatePackageUnitData[]
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/units/bulk`,
      { units }
    );
    return response.data;
  },

  // Update a unit in a package
  update: async (
    workspaceId: string,
    packageId: string,
    unitId: string,
    data: UpdatePackageUnitData
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/units/${unitId}`,
      data
    );
    return response.data;
  },

  // Update multiple units in a package
  updateMultiple: async (
    workspaceId: string,
    packageId: string,
    units: UpdatePackageUnitData[]
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/units/bulk`,
      { units }
    );
    return response.data;
  },

  // Remove a unit from a package
  delete: async (
    workspaceId: string,
    packageId: string,
    unitId: string
  ) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/units/${unitId}`
    );
    return response.data;
  }
};
